<script lang="ts">
  import Section from "$lib/molecules/Section.svelte";
  import Button from "$lib/atoms/Button.svelte";
  import { ButtonColor, IconType } from "$types/atoms";
  import CareersPreviewCard from "$lib/molecules/careers/CareersPreviewCard.svelte";
  import CareersFilters from "$lib/molecules/careers/CareersFilters.svelte";
  import { onMount } from "svelte";
  import {
    careersMobileFiltersOpen,
    jobs as storeJobs,
    filteredJobs,
    jobsSearch,
    selectedCareersLocations,
    selectedCareersDepartments,
  } from "$stores";

  export let blok: any;

  $: jobs = [];
  let initialShown = 20;
  let shown = initialShown;

  onMount(async () => {
    const res = await fetch("/api/careers");
    const data = await res.json();
    storeJobs.set(data);
  });

  filteredJobs.subscribe((fj) => {
    jobs = fj;
    // reset the shown counter
    shown = initialShown;
  });
</script>

<Section {blok} class="pt-small !z-[6]">
  <div class="container">
    <div class="flex -ml-[40px] lg:-ml-[78px]">
      <div
        class="hidden md:block flex-[0_0_300px] lg:flex-[0_0_384px] pl-[40px] lg:pl-[78px]"
      >
        <div class="top-section">
          <!-- Header -->
          <div class="space-y-5">
            <h6 class="type:h5-eyebrow">Job Listing</h6>
            <h3 class="type:h3">Find your place</h3>
          </div>
        </div>

        <div class="hidden md:block">
          <CareersFilters />
        </div>
      </div>

      <div class="flex-auto pl-[40px] lg:pl-[78px]">
        <div class="top-section">
          <section class="pt-8">
            <form
              action="#"
              class="mb-4 relative"
              style="border-bottom:1px solid #797978"
            >
              <input
                bind:value={$jobsSearch}
                type="text"
                name="search"
                placeholder="Search"
                autocomplete="one-time-code"
                class="appearance-none outline-none text-[18px] bg-transparent h-[53px] w-full border-none"
              />
              <div
                class="absolute inset-0 left-auto right-[4px] flex items-center"
              >
                <svg
                  class="h-[13px] w-[13px]"
                  viewBox="0 0 13 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  ><path
                    d="M9.076 8.047h-.542l-.192-.185A4.44 4.44 0 0 0 9.42 4.96a4.46 4.46 0 1 0-4.46 4.46 4.44 4.44 0 0 0 2.903-1.078l.185.192v.542l3.43 3.424 1.023-1.022-3.424-3.43zm-4.116 0A3.083 3.083 0 0 1 1.872 4.96 3.083 3.083 0 0 1 4.96 1.872 3.083 3.083 0 0 1 8.047 4.96 3.083 3.083 0 0 1 4.96 8.047z"
                    fill="#8b8888"
                  /></svg
                >
              </div>
            </form>
          </section>
        </div>

        <div class="md:hidden mb-6">
          <div class="mobile-careers-filter-toggle">
            <div
              class="flex items-center space-x-3 cursor-pointer"
              tabindex="-1"
              role="button"
              on:keydown={() =>
                careersMobileFiltersOpen.set(!$careersMobileFiltersOpen)}
              on:click={() =>
                careersMobileFiltersOpen.set(!$careersMobileFiltersOpen)}
            >
              <div>Open filters</div>
              <div>
                <svg
                  class="!w-[16px] !h-[13px]"
                  viewBox="0 0 16 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  ><path
                    d="M12.711 12.756c-.78 0-1.44-.27-1.98-.808-.538-.54-.808-1.2-.808-1.98s.27-1.44.809-1.98c.539-.539 1.199-.809 1.98-.809.78 0 1.44.27 1.98.81.538.538.808 1.198.808 1.979 0 .78-.27 1.44-.809 1.98-.539.539-1.199.808-1.98.808zm0-1.25c.424 0 .787-.15 1.088-.45.3-.3.451-.663.451-1.087 0-.425-.15-.788-.45-1.088a1.48 1.48 0 0 0-1.088-.452c-.424 0-.787.15-1.088.45-.3.301-.451.663-.451 1.088 0 .425.15.787.45 1.088.3.301.663.451 1.088.451zM1.75 10.593v-1.25h6.346v1.25H1.75zm1.538-5.016c-.78 0-1.44-.27-1.98-.809C.77 4.23.5 3.57.5 2.788c0-.78.27-1.44.809-1.98C1.848.27 2.508 0 3.289 0c.78 0 1.44.27 1.98.809.538.539.808 1.199.808 1.98 0 .78-.27 1.44-.809 1.98-.539.538-1.199.808-1.98.808zm0-1.25c.424 0 .787-.15 1.088-.45.3-.3.45-.663.45-1.088 0-.424-.15-.787-.45-1.088A1.48 1.48 0 0 0 3.29 1.25c-.424 0-.787.15-1.088.45-.3.3-.451.663-.451 1.088 0 .424.15.787.45 1.088.3.3.663.45 1.088.45zm4.616-.914v-1.25h6.346v1.25H7.904z"
                    fill="#242021"
                  /></svg
                >
              </div>
            </div>

            <div
              class="fixed inset-0 z-[9999] bg-[rgb(var(--color-light-grey))] {$careersMobileFiltersOpen ===
              true
                ? 'block'
                : 'hidden'}"
            >
              <div
                class="pb-[40px] pt-[80px] px-[20px] h-screen overflow-y-auto flex flex-col"
              >
                <div class="flex-auto">
                  <CareersFilters isMobileVersion={true} />
                </div>
                <div class="buttons flex space-x-4 mt-8">
                  <Button
                    class="flex-auto button bordered !bg-transparent !text-[#242021]"
                    on:click={() => {
                      selectedCareersLocations.set([]);
                      selectedCareersDepartments.set([]);
                      jobsSearch.set("");
                    }}
                  >
                    Clear all filters
                  </Button>
                  <Button
                    color={ButtonColor.BLACK}
                    class="flex-auto  button"
                    on:click={() => {
                      careersMobileFiltersOpen.set(false);
                    }}
                  >
                    Apply filters
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="space-y-6">
          <!-- {JSON.stringify($selectedCareersLocations)} -->
          {#if jobs.length > 0}
            {#each jobs as job, i}
              {#key job.id}
                {#if i < shown}
                  <div>
                    <CareersPreviewCard {job} />
                  </div>
                {/if}
              {/key}
            {/each}

            {#if jobs.length > shown}
              <div class="flex justify-center">
                <Button
                  on:click={() => (shown += initialShown)}
                  color={ButtonColor.BLACK}>Show more</Button
                >
              </div>
            {/if}
          {:else if !$storeJobs.length}
            <div>Loading</div>
          {:else}
            <div>No jobs matching criteria found</div>
          {/if}
        </div>
      </div>
    </div>
  </div>
</Section>

<style lang="scss">
  .top-section {
    height: 140px;
  }
</style>
